import Control from "./Control.js"

export default class JumpForward extends Control {

  constructor(props, context) {
    super(props, context)
    this.classList.add("amp-jump-forward", true)
    this.state.altText = "MSG_JUMP_AHEAD"
  }

  static get contextTypes() {
    return super.contextTypes
  }

  onClick(event) {
  	const player = this.player
    if (!player.ended && (player.playState == "playing" || player.playState == "paused")) {
      player.currentTime = Math.min(this.player.currentTime + 10, this.player.duration - 1)
    }
  }

}
